import { Component } from "react";
import * as React from "react";

interface IButtonProps {
	background?: string;
	color?: string;
	onClick: () => void;
}

export class Button extends Component<IButtonProps> {
	public constructor(props: IButtonProps) {
		super(props);
	}

	public render() {
		return <button onClick={this.props.onClick} className="button" style={{ background: this.props.background, color: this.props.color}}>{this.props.children}</button>
	}
}


// WEBPACK FOOTER //
// ./src/components/controls/Button.tsx